export const PRODUCT_CONTAINER_PRODUCT_TARGET_ENABLED = true;

export function isProductContainerCreateEnabled(): boolean {
	return PRODUCT_CONTAINER_PRODUCT_TARGET_ENABLED;
}
